export function orderByRadioLoader($, $radioGroup) {
    const $orderByRadiosInputs = $radioGroup.find('.js-order-by-radio');

    $orderByRadiosInputs.on('change', () => {
        $orderByRadiosInputs.filter(':checked').each((index, element) => {
            const $el = $(element);
            const thisName = $el.attr('name');
            const thisVal = $el.attr('value');
            $(`select[name="${thisName}"]`).val(thisVal).trigger('change');
        });
    });
}

export function orderByFormLoader($) {
    $('.js-order-by-radios').each((index, radioGroup) => {
        orderByRadioLoader($, $(radioGroup));
    });
}
